import styled, { css } from "styled-components";
import colors from "../../../assets/styles/colors";
import { device } from "../../../assets/styles/size";

export const DetalleGridItemWrapper = styled.div`
	${(props) => {
		props.cols === "1" &&
			css`
				margin-left: -6px;
				margin-right: -6px;
				display: flex;
				flex-wrap: wrap;
			`;
		props.noPaddingTopBot &&
			css`
				padding-top: 0;
				padding-bottom: 0;
			`;
		props.noPaddingTop &&
			css`
				padding-top: 0;
			`;
		props.noPaddingBot &&
			css`
				padding-bottom: 0;
			`;
	}}
`;

export const HeaderTop = styled.div`
	margin-bottom: 40px;
	@media ${device.laptopL} {
		/* margin-bottom: 60px; */
	}
	h2 {
		margin: 0;
		font-family: "AudiType-Extended";
		font-size: 20px;
		line-height: 1.2;
		@media ${device.tablet} {
			font-size: 30px;
		}
		@media ${device.laptopL} {
			font-size: 35px;
		}
	}
	h3 {
		font-family: "AudiType-Extended";
		font-weight: normal;
		font-size: 20px;
		@media ${device.tablet} {
			font-size: 22px;
		}
		@media ${device.laptopL} {
			font-size: 24px;
		}
	}
`;

export const PriceNote = styled.div`
	p {
		font-size: 12px;
		line-height: 1.2;
		margin: 0;
		@media ${device.tablet} {
			font-size: 15px;
		}
		@media ${device.laptopL} {
			font-size: 17px;
		}
	}
`;

export const HeaderInfo = styled.div`
	margin-bottom: ${(props) => (props.cols === "1" ? "0" : "20px")};
	position: relative;

	h3 {
		// font-weight: ${(props) => (props.cols === "1" ? 700 : 400)};
		font-size: 25px;
		line-height: 1.2;
		margin: 0 0 17px;
		font-weight: 400;
		text-transform: capitalize;
		strong {
			text-transform: none;
		}
	}

	h4 {
		font-family: "AudiType-Extended";
		font-weight: ${(props) => (props.cols === "1" ? 400 : 700)};
		font-size: 20px;
		line-height: 1.2;
		margin: 0 0 10px -1px;
		span {
			font-weight: 700;
		}
	}

	h6 {
		font-family: "AudiType-Extended";
		font-weight: normal;
	}

	@media ${device.tablet} {
		h3 {
			font-size: 30px;
		}

		h4 {
			font-size: ${(props) => (props.priceExtra ? "20px" : "22px")};
		}
	}
	@media ${device.laptopL} {
		margin-bottom: ${(props) => (props.cols === "1" ? "0" : "30px")};

		h4 {
			font-size: ${(props) => (props.priceExtra ? "26px" : "28px")};
		}
	}
	@media ${device.desktopS} {
		margin-bottom: ${(props) => (props.cols === "1" ? "0" : "40px")};

		h4 {
			font-size: ${(props) => (props.priceExtra ? "28px" : "30px")};
		}
	}
`;

export const ButtonsWrapper = styled.div`
	${(props) => {
		if (props.cols === "1") {
			return css`
				display: block;

				div {
					margin-bottom: 10px;
					height: 100%;
					&:last-of-type {
						margin-bottom: 0;
					}
					a {
						padding: 20px 0;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}
			`;
		} else {
			return css`
				display: flex;
				flex-wrap: wrap;
				margin-left: -6px;
				margin-right: -6px;

				div {
					box-sizing: border-box;
					flex: 0 0 100%;
					max-width: 100%;
					margin-bottom: 10px;
					&:last-of-type {
						margin-bottom: 0;
					}
					a {
						padding: 0;
						height: 44px;
						display: flex;
						flex-wrap: wrap;
						justify-content: center;
						align-items: center;
						text-align: center;
					}
					@media ${device.tablet} {
						padding: 0 6px;
						flex: 0 0 50%;
						max-width: 50%;
						margin-bottom: 0;
					}
					@media ${device.laptopL} {
						a {
							height: 70px;
						}
					}
				}
			`;
		}
	}};
`;

export const Header = styled.div`
	position: relative;
	border: 1px solid ${colors.gray};
	padding: 34px 24px;
	margin-bottom: 10px;
	${(props) =>
		props.cols === "1" &&
		css`
			border-top: 0;
			${HeaderTop} {
				width: 100%;
			}
			${HeaderInfo} {
				margin-bottom: 20px;
			}
			@media ${device.tabletL} {
				border-top: 1px solid ${colors.gray};
			}
			@media ${device.laptopS2} {
				border: 1px solid ${colors.gray};
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				${HeaderInfo} {
					margin-bottom: 0;
					max-width: 65%;
					flex: 0 0 65%;
				}
				${ButtonsWrapper} {
					max-width: 32%;
					flex: 0 0 32%;
				}
			}
		`};

	figure {
		margin: 0 0 26px;

		img {
			width: 100%;
		}
	}

	a {
		width: 100%;
		box-sizing: border-box;
	}
`;

export const Model = styled.div`
	background-color: ${colors.grayLight};
	//border: 1px solid ${colors.gray};
	padding: 18px 22px;
	margin-bottom: 13px;
	p {
		margin: 0;
		padding: 0;
		font-size: 18px;
		@media ${device.laptopL} {
			font-size: 20px;
		}
	}
`;

export const ImgCol = styled.div`
	padding-left: 6px;
	padding-right: 6px;
	box-sizing: border-box;
	max-width: 100%;
	flex: 0 0 100%;
	position: relative;
	@media ${device.tabletL} {
		max-width: calc(40% - 6px);
		flex: 0 0 calc(40% - 6px);
	}
	@media ${device.laptopL} {
		max-width: calc(48% - 6px);
		flex: 0 0 calc(48% - 6px);
	}
	figure {
		border: 1px solid ${colors.gray};
		border-bottom: 0;
		padding: 24px 24px 0;
		margin: 0;
		width: 100%;
		height: ${(props) => props.fixedHeight && props.fixedHeight};
		transition: height 0.1s ease;
		box-sizing: border-box;
		@media ${device.tabletL} {
			position: absolute;
			left: 0;
			top: 0;
			border: 1px solid ${colors.gray};
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
`;
export const InfoCol = styled.div`
	padding-left: 6px;
	padding-right: 6px;
	box-sizing: border-box;
	max-width: 100%;
	flex: 0 0 100%;
	@media ${device.tabletL} {
		margin-left: auto;
		max-width: 60%;
		flex: 0 0 60%;
	}
	@media ${device.laptopL} {
		max-width: 52%;
		flex: 0 0 52%;
	}
`;
